module.exports = __webpack_public_path__ + "static/media/SelectArriba.b88993ed.svg";